import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Routes importing
import { BrowserRouter as Router, Route, Routes, Navigate, HashRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";

// Importing Pages Auth
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";

// Importing main pages
import Home from "./pages/main/Home";
import Statutory from './pages/pages/Statutory';
// The navlink pages
import Landing from "./pages/main/Landing";
import Configure from './pages/main/Configure';
import Utility from './pages/main/Utilities';
import ProfileOld from './pages/main/Profile';
import ReportsOld from './pages/main/Reports';

// other pages
import AddHouse from './pages/pages/AddHouse'
import AddProperty from './pages/pages/AddProperty';
import ApartmentImage from './pages/pages/ApartmentImage';
import HouseImage from "./pages/pages/HouseImage";

// new dashboard
import Dashboard from "./pages/newDashboard/Dashboard";
import Property from './pages/newDashboard/Property';
import SelectedProperty from './pages/newDashboard/SelectedProperty';
import HomeAddProperty from './pages/pages/HomeAddProperty';
import SelectedHouse from './pages/newDashboard/SelectedHouse';
import Utilities from "./pages/newDashboard/Utilities";
import SelectedPropertyUtilities from "./pages/newDashboard/SelectedPropertyUtilities";
import Profile from "./pages/newDashboard/Profile";
import MyTable from './pages/newDashboard/MyTable';
import PdfR from './pages/newDashboard/PdfR';
import Account from './pages/newDashboard/Account';

// reports
import RentPaymentReport from './pages/newDashboard/reports/RentPaymentReport';
import UtilitiesReport from './pages/newDashboard/reports/UtilitiesReport';
import OccupancyReport from './pages/newDashboard/reports/OccupancyReport';
import IncomeReport from './pages/newDashboard/reports/IncomeReport';
import OwnersReport from './pages/newDashboard/reports/OwnersReport';
import Reports from './pages/newDashboard/reports/Reports';
import SelectedApartmentReport from './pages/newDashboard/reports/SelectedApartmentReport';
import TenantReports from './pages/newDashboard/reports/TenantReports';
import IssueReport from "./pages/newDashboard/reports/IssueReport";
import HistoryReport from "./pages/newDashboard/reports/HistoryReport";
import Table from "./pages/pages/Table";
import Repairs from './pages/newDashboard/Repairs';
import SelectedApartmentRepairs from './pages/newDashboard/SelectedApartmentRepairs';
import PageAddApartment from "./pages/pages/PageAddApartment";
import AddTenant from "./pages/newDashboard/AddTenant";
import SelectedHouseImage from "./pages/newDashboard/SelectedHouseImage";
import SelectedPropertyImage from "./pages/newDashboard/SelectedPropertyImage";
import ImageResize from "./pages/newDashboard/ImageResize";
import Messages from "./pages/newDashboard/Messages";
import BulkUploads from "./pages/newDashboard/BulkUploads";
import Wallet from "./pages/newDashboard/Wallet";
import WalletLogin from "./pages/newDashboard/WalletLogin";
import MainWallet from "./pages/newDashboard/MainWallet";
import WalletOtp from "./pages/newDashboard/WalletOtp";
import FailedReconciliation from "./pages/newDashboard/reports/FailedReconciliation";
import OverflowReport from "./pages/newDashboard/reports/OverflowReport";
import ForgotPasword from "./pages/auth/ForgotPasword";
import WalletProperty from "./pages/newDashboard/WalletProperty";
import SubscriptionDashboard from "./pages/newDashboard/SubscriptionDashboard";

import SelectedWalletPlan from "./pages/newDashboard/SelectedWalletPlan";
import NewPlan from "./pages/newDashboard/NewPlan";
import MakeSubscriptionPayment from "./pages/newDashboard/MakeSubscriptionPayment";
import Blogs from "./pages/newDashboard/Blog";
import BlogsAdd from "./pages/newDashboard/BlogAdd";
import SelectedBlog from "./pages/newDashboard/SelectedBlog";
import SelectedBlogImage from "./pages/newDashboard/SelectedBlogImage";
import AddRoomImage from "./pages/pages/AddRoomImage";
import RoomAdd from "./pages/newDashboard/RoomAdd";
import BlogEdit from "./pages/newDashboard/BlogEdit";
import ApartmentIssueReport from "./pages/newDashboard/reports/ApartmentIssueReport";
import UnpaidInvoice from "./pages/newDashboard/UnpaidInvoice";
import DefaultersLandlord from "./pages/newDashboard/DefaultersLandlord";
import PropertySettingsPage from "./pages/app/admin/property_settings/page.tsx";
import PropertySettingId from "./pages/app/admin/property_settings/[id]/page.tsx";
import Invoicing from "./pages/newDashboard/Invoicing.jsx";
// import Invoicing from "./pages/app/admin/invoicing/page.jsx";
import SalesLedger from "./pages/app/admin/sales_ledger/page.jsx";
import LedgerReports from "./pages/app/admin/legder_report/page.jsx";
import ForgotPasswordPage from "./pages/app/admin/forgot_password/page.jsx";
import DashboardPage from "./pages/app/admin/dashboard/page.jsx";
import ResetPassword from "./pages/auth/ResetPassword.jsx";

function RootRedirect() {
  const isAuthenticated = localStorage.getItem('authTokens') !== null;
  const location = useLocation();

  if (location.pathname === "/") {
    if (isAuthenticated) {
      return <Navigate to="/dashboard" replace />;
    } else {
      return <Navigate to="/landing-page" replace />;
    }
  }
  // If not on /, but not authenticated and not on landing-page, redirect to /home
  if (!isAuthenticated && location.pathname !== "/landing-page") {
    return <Navigate to="/home" replace />;
  }
  return null;
}

function WebRoutes() {
  return (
    <div className={`App app_`}>
      <ToastContainer />
      <HashRouter>
        <RootRedirect />
        <Routes>
          <Route path="/home" Component={Dashboard} />
          <Route path="/landing-page" Component={Home} />
          <Route path="/forgot-password" Component={ForgotPasword} />
          <Route path='/unpaid-invoice' Component={UnpaidInvoice} />
          <Route path='/reset-password/:uidb64/:token/:tokenValid' Component={ResetPassword} />
          <Route path="/statutory" Component={Statutory} />
          <Route path="/add-house" Component={AddHouse} />
          <Route path="/add-property" Component={AddProperty} />
          <Route path="/add-apartment" Component={PageAddApartment} />
          <Route path="/Apartment-image" Component={ApartmentImage} />
          <Route path="/house-image" Component={HouseImage} />
          <Route path='/blog' Component={Blogs} />
          <Route path="/add-blog" Component={BlogsAdd} />
          <Route path="/defaulters-list" Component={DefaultersLandlord} />
          <Route path='/selected-blog/:id' Component={SelectedBlog} />
          <Route path='/selected-blog-image/:id' Component={SelectedBlogImage} />
          <Route path="/property" Component={Property} />
          <Route path="/bulk" Component={BulkUploads} />
          <Route path="/selected-property/:id" Component={SelectedProperty} />
          <Route path="/selected-property-image/:id" Component={SelectedPropertyImage} />
          <Route path="/configure" Component={Configure} />
          <Route path="/utilities" Component={Utilities} />
          <Route path="/profile" Component={Profile} />
          <Route path="/reports" Component={Reports} />
          <Route path="/messages" Component={Messages} />
          <Route path="/expense" Component={Repairs} />
          <Route path="/selected-apartment-repairs/:id" Component={SelectedApartmentRepairs} />
          <Route path='/home-property' Component={HomeAddProperty} />
          <Route path='/selected-house/:id' Component={SelectedHouse} />
          <Route path='/selected-house-image/:id' Component={SelectedHouseImage} />
          <Route path='/selected-property-utility/:id' Component={SelectedPropertyUtilities} />
          <Route path='/selected-property-report/:id' Component={SelectedApartmentReport} />
          <Route path='/subscription' Component={SubscriptionDashboard} />
          <Route path='/wallet-data/:id' Component={SelectedWalletPlan} />
          <Route path='/new-plan/:id' Component={NewPlan} />
          <Route path="/room-image/:id" Component={AddRoomImage} />
          <Route path="/add-room/:id" Component={RoomAdd} />
          <Route path="/edit-blog/:id" Component={BlogEdit} />
          <Route path='/occupancy-report/:id' Component={OccupancyReport} />
          <Route path='/income-report/:id' Component={IncomeReport} />
          <Route path='/payment-report/:id' Component={RentPaymentReport} />
          <Route path='/utility-report/:id' Component={UtilitiesReport} />
          <Route path='/failed-report/:id' Component={FailedReconciliation} />
          <Route path='/overpayment-report/:id' Component={OverflowReport} />
          <Route path='/owner-report/:id' Component={OwnersReport} />
          <Route path='/issue-report/:id' Component={IssueReport} />
          <Route path='/make-payment/:id' Component={MakeSubscriptionPayment} />
          <Route path='/tenants-feedback/:id' Component={ApartmentIssueReport} />
          <Route path='/tenant-report/:id' Component={TenantReports} />
          <Route path='/issue-report/:id' Component={IssueReport} />
          <Route path='/history-report/:id' Component={HistoryReport} />
          <Route path='/wallet' Component={MainWallet} />
          <Route path='/property-wallet/:id' Component={Wallet} />
          <Route path='/wallet-otp' Component={WalletOtp} />
          <Route path='/wallet-property/:id' Component={WalletProperty} />
          <Route path='/wallet-login' Component={WalletLogin} />
          <Route path='/table' Component={Table} />
          <Route path='pdf' Component={PdfR} />
          <Route path='/update-profile' Component={ImageResize} />
          <Route path="add-tenant/:id/:housetenant" Component={AddTenant} />
          <Route path='/account/:id' Component={Account} />
          <Route path='/my-table' Component={MyTable} />
          <Route path="/login" Component={Login} />
          <Route path="/register" Component={Register} />
          <Route path="/dashboard" Component={Dashboard} />
          <Route path="/statutory" Component={Statutory} />
          <Route path="/add-house" Component={AddHouse} />
          <Route path="/add-property" Component={AddProperty} />
          <Route path="/Apartment-image" Component={ApartmentImage} />
          <Route path="/house-image" Component={HouseImage} />
          <Route path="/property-settings" Component={PropertySettingsPage} />
          <Route path="/property-settings/:id" Component={PropertySettingId} />
          <Route path="/invoicing/:id" Component={Invoicing} />
          <Route path="/category-c" Component={SalesLedger} />
          <Route path="/ledger-reports" Component={LedgerReports} />
          <Route path="/forgot" Component={ForgotPasswordPage} />
          <Route path="/dashboard-new" Component={DashboardPage} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default WebRoutes;
